
export enum AuctionDeliveryMethod {
  Unknown = 0,
  Delivery = 1,
  PickUp = 2,
  DeliveryAndPickUp = 3
}
